import React, { FC } from 'react';

import NextLink from 'next/link';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { Link, Text } from '@whitesharx/starfall-frontend-ui-kit';
import { PageInfoHeader, PageInfoHeaderProps, Routes } from '@whitesharx/starfall-frontend-core';

export type PageLayoutHeaderProps = Omit<PageInfoHeaderProps, 'HomeLink'>;

const PageLayoutHeader: FC<PageLayoutHeaderProps> = (props) => {
  const HomeLink = (
    <NextLink key="homeLink" href={Routes.index} passHref>
      <Link>
        <Text fontSize="12px" color="purple100" textTransform="uppercase">
          {t('home')}
        </Text>
      </Link>
    </NextLink>
  );

  return <PageInfoHeader HomeLink={HomeLink} {...props} />;
};

export default PageLayoutHeader;
